import React, { useMemo } from 'react';
import { motion } from 'motion/react';

interface InsightsWidgetLoaderProps {
  showLoadingText?: boolean;
}

// Bar heights as percentages for responsive scaling
const BAR_HEIGHT_PERCENTAGES = [27, 55, 82, 64, 91, 73, 100, 86];

const InsightsWidgetLoader: React.FC<InsightsWidgetLoaderProps> = ({
  showLoadingText = true,
}) => {
  const skeletonBars = useMemo(
    () =>
      BAR_HEIGHT_PERCENTAGES.map((heightPercent, index) => (
        <div
          key={`skeleton-bar-${index}`}
          className="data-bar max-w-10 flex-1 rounded-t bg-linear-to-t from-transparent to-blue-500"
          style={{
            height: `${heightPercent}%`,
            animationDelay: `${0.2 * (index + 1)}s`,
            transformOrigin: 'bottom',
          }}
        />
      )),
    [],
  );

  return (
    <div className="relative flex w-full flex-1 items-center justify-center rounded-xl bg-white">
      {/* Skeleton Chart Bars */}
      <div className="pointer-events-none absolute inset-0 flex items-end justify-center gap-2 opacity-10">
        {skeletonBars}
      </div>

      {/* Loading Text */}
      {showLoadingText && (
        <motion.div
          initial={{ opacity: 0, filter: 'blur(4px)', y: 15 }}
          animate={{ opacity: 1, filter: 'blur(0px)', y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="z-10 text-center"
        >
          <div className="text-xs font-medium text-gray-500">
            Fetching insights for you. We'll make it worth your wait
          </div>
        </motion.div>
      )}
    </div>
  );
};

export default InsightsWidgetLoader;
